export const people = {
  extends: 'Page',
  metadata: { title: 'People / Symbols Workspace' },
  flow: 'x',
  align: 'flex-start',
  gap: 'D',
  padding: 'D C',
  maxWidth: 'none',
  margin: '0 auto',
  width: '100%',

  PpRail: {
    flow: 'y',
    gap: 'C',
    width: 'G',
    minWidth: 'G',
    flex: '0 0 auto',
    position: 'sticky',
    top: 'D',

    PpHeading: {
      flow: 'y',
      gap: 'A',
      PpEyebrow: { tag: 'span', fontSize: 'Z2', fontWeight: '700', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'blue', text: 'The team' },
      PpTitle: { tag: 'h1', fontSize: 'D', fontWeight: '800', color: 'title', letterSpacing: '-0.03em', lineHeight: '1.1', margin: '0', text: 'People' }
    },

    PpCategories: {
      flow: 'y',
      gap: 'Z',
      paddingTop: 'B',
      borderTopWidth: '1px',
      borderTopStyle: 'solid',
      borderTopColor: 'line',
      PpCatHead: { tag: 'span', fontSize: 'Y2', fontWeight: '700', color: 'caption', textTransform: 'uppercase', letterSpacing: '0.08em', text: 'Teams' },
      PpCatAll: { extends: 'PeopleFilterLink', state: { name: null, kind: 'group', label: 'Everyone' } },
      PpCatList: {
        flow: 'y',
        gap: 'Y',
        childExtends: 'PeopleFilterLink',
        childrenAs: 'state',
        children: (el) => el.call('peopleGroupCategories')
      }
    },

    PpTeamCategories: {
      // Category filter (Active / External) — I11 team-category model.
      // Replaces the legacy Supabase-user-role sidebar.
      flow: 'y',
      gap: 'Z',
      paddingTop: 'B',
      borderTopWidth: '1px',
      borderTopStyle: 'solid',
      borderTopColor: 'line',
      PpTcHead: { tag: 'span', fontSize: 'Y2', fontWeight: '700', color: 'caption', textTransform: 'uppercase', letterSpacing: '0.08em', text: 'Category' },
      PpTcAll: { extends: 'PeopleFilterLink', state: { name: null, kind: 'category', label: 'Everyone' } },
      PpTcList: {
        flow: 'y',
        gap: 'Y',
        childExtends: 'PeopleFilterLink',
        childrenAs: 'state',
        children: (el) => el.call('peopleTeamCategories')
      }
    }
  },

  PpBody: {
    flow: 'y',
    gap: 'D',
    flex: '1',
    minWidth: '0',

    PpGroups: {
      flow: 'y',
      gap: 'D',
      childExtends: 'PeopleGroupBlock',
      childrenAs: 'state',
      children: (el) => el.call('groupFilteredPeople')
    }
  }
}
